<template>
    <div v-if="direction ==  'sent'" class="dd-message">        
        <div class="pr-2">
            <dd-avatar
                :user="user"
                size="bit-larger"
            >

            </dd-avatar>
        </div>
        <div class="dd-message-text">
            {{message}}
            <div class="dd-timestamp">{{ timestamp | time }}</div>
        </div>        
    </div>
    <div v-else class="dd-message-right" >        
        
        <div class="dd-message-text-right">
            {{message}}
            <div class="dd-timestamp">{{ timestamp | time }}</div>
        </div>  
        <div class="pl-2">
            <dd-avatar
                :user="user"
                size="bit-larger"
            >

            </dd-avatar>
        </div>      
    </div>
</template>
<script>
import DdAvatar from './DdAvatar'

export default {
    components: {
        DdAvatar
    },
    props: {
        direction: {
            required: true,
            type: String,        
            validator: function (value) {
                // The value must match one of these strings
                return ['sent', 'received'].indexOf(value) !== -1
            }        
        },
        user: {
            required: true,
            type: Object,
            default: {person: {firstName:'test'}}
        },
        message:{
            required: true,
            type: String
        },
        timestamp:{
            required: true
        },
        color:{
            default: '#ddd'
        },
        textColor:{
            default: '#000'
        }
      },
    }

</script>
<style>
    .dd-message-from{
    }

    .dd-message-text{
        background-color: #81c784;
        
        padding: 4px 8px;
        border-radius: 4px 4px 4px 0;
        
    }

    .dd-message-text-right{
        background-color: #ddd;
        
        padding: 4px 8px;
        border-radius: 4px 4px 4px 0;
        
    }

    .dd-message{
        display: flex;
        width: calc(50% ) !important;
    }

    .dd-message-right{
        text-align: end;
        
        justify-content: flex-end;
        display: flex;
        margin-left: 50%;
        width: calc(50% ) !important;
    }

    .dd-timestamp{
        text-align: right;
        font-weight: 300;
    }
</style>